<cdk-virtual-scroll-viewport
  [itemSize]="RowHeight"
  bitScrollLayout
  class="tw-transition-[padding-bottom] tw-duration-300 tw-ease-in-out"
  [ngClass]="batchBarService.barVisible() ? 'tw-pb-[7.5rem]' : 'tw-pb-8'"
>
  <bit-table [dataSource]="dataSource" layout="fixed">
    <ng-container header>
      <tr>
        <th bitCell class="tw-w-24 tw-whitespace-nowrap" colspan="2">
          <input
            type="checkbox"
            bitCheckbox
            [disabled]="disabled || isEmpty"
            (change)="$event ? toggleAll() : null"
            [checked]="selection.hasValue() && isAllSelected"
            [attr.aria-label]="'selectAll' | i18n"
          />
        </th>
        <!-- Organization vault -->
        @if (showAdminActions) {
          <th
            bitCell
            bitSortable="name"
            [fn]="sortByName"
            [class]="showExtraColumn ? 'tw-w-3/5' : 'tw-w-full'"
          >
            {{ "name" | i18n }}
          </th>
        }
        <!-- Individual vault -->
        @else {
          <th bitCell [class]="showExtraColumn ? 'tw-w-3/5' : 'tw-w-full'">
            {{ "name" | i18n }}
          </th>
        }
        @if (showOwner) {
          <th bitCell class="tw-hidden tw-w-2/5 lg:tw-table-cell">
            {{ "owner" | i18n }}
          </th>
        }
        @if (showCollections) {
          <th bitCell class="tw-w-2/5 tw-hidden xl:tw-table-cell">
            {{ "collections" | vfo1I18n: "sharedFolders" }}
          </th>
        }
        @if (showGroups) {
          <th
            bitCell
            bitSortable="groups"
            [fn]="sortByGroups"
            class="tw-hidden tw-w-2/5 tw-pr-7 xl:tw-table-cell"
          >
            {{ "groups" | i18n }}
          </th>
        }
        @if (showPermissionsColumn) {
          <th
            bitCell
            bitSortable="permissions"
            default="desc"
            [fn]="sortByPermissions"
            class="tw-hidden tw-w-2/5 tw-pr-7 lg:tw-table-cell"
          >
            {{ "permission" | i18n }}
          </th>
        }
        @if (showControlledAccess) {
          <th bitCell class="tw-hidden tw-w-40 lg:tw-table-cell">
            {{ "controlledAccess" | i18n }}
          </th>
        }
        <th
          bitCell
          class="tw-text-right"
          [ngClass]="optionsColumnWidthClass((showQuickCopyActions$ | async) ?? false)"
        >
          {{ "options" | i18n }}
        </th>
      </tr>
    </ng-container>
    <ng-template body let-rows$>
      <ng-container *cdkVirtualFor="let item of rows$; templateCacheSize: 0">
        @if (item.collection) {
          <tr
            bitRow
            appVaultCollectionRow
            alignContent="middle"
            [disabled]="disabled"
            [collection]="item.collection"
            [showOwner]="showOwner"
            [showCollections]="showCollections"
            [showGroups]="showGroups"
            [organizations]="allOrganizations"
            [showPermissionsColumn]="showPermissionsColumn"
            [showControlledAccess]="showControlledAccess"
            [groups]="allGroups"
            [canDeleteCollection]="canDeleteCollection(item.collection)"
            [canEditCollection]="canEditCollection(item.collection)"
            [canViewCollectionInfo]="canViewCollectionInfo(item.collection)"
            [checked]="selection.isSelected(item)"
            (checkedToggled)="selection.toggle(item)"
            (onEvent)="event($event)"
          ></tr>
        }
        <!--
          addAccessStatus check here so ciphers do not show if user
          has filtered for collections with addAccess
        -->
        @if (item.cipher && (!addAccessToggle || (addAccessToggle && addAccessStatus !== 1))) {
          <tr
            bitRow
            appVaultCipherRow
            alignContent="middle"
            [disabled]="disabled"
            [cipher]="item.cipher"
            [showOwner]="showOwner"
            [showCollections]="showCollections"
            [showGroups]="showGroups"
            [showControlledAccess]="showControlledAccess"
            [useEvents]="useEvents"
            [viewingOrgVault]="viewingOrgVault"
            [cloneable]="canClone$(item) | async"
            [organizations]="allOrganizations"
            [collections]="allCollections"
            [checked]="selection.isSelected(item)"
            [canEditCipher]="canEditCipher(item.cipher)"
            [canAssignCollections]="canAssignCollections(item.cipher)"
            [canManageCollection]="canManageCollection(item.cipher)"
            [canDeleteCipher]="
              cipherAuthorizationService.canDeleteCipher$(item.cipher, showAdminActions) | async
            "
            [canRestoreCipher]="
              cipherAuthorizationService.canRestoreCipher$(item.cipher, showAdminActions) | async
            "
            (checkedToggled)="selection.toggle(item)"
            (onEvent)="event($event)"
            [userCanArchive]="userCanArchive"
            [enforceOrgDataOwnershipPolicy]="enforceOrgDataOwnershipPolicy"
          ></tr>
        }
      </ng-container>
    </ng-template>
  </bit-table>
</cdk-virtual-scroll-viewport>
